<p-toggleButton
    [formControl]="formControl"
    [styleClass]="'form-control'"
    (onChange)="change($event)"
    [onLabel]="onLabel"
    [offLabel]="offLabel"
    [onIcon]="onIcon"
    [offIcon]="offIcon"
></p-toggleButton>
